import clipboard from 'v-clipboard';
import { createApp } from 'vue';
import vueCookies from 'vue-cookies';
import { createI18n } from 'vue-i18n';

import router from '@/router';
import { messages } from '@/translations/messages.js';

import App from './App.vue';
import './registerServiceWorker';

export const i18n = new createI18n({
  legacy: false,
  locale: 'sk',
  fallbackLocale: 'sk',
  messages,
  silentTranslationWarn: import.meta.env.NODE_ENV === 'production',
});

export const app = createApp(App);
app.use(clipboard);
app.use(vueCookies);
app.use(i18n);
app.use(router);

app.mount('#app');
